import React, { useState } from "react";

const NotificationToggle = () => {
  const [showMessage, setShowMessage] = useState(false);

  const handleToggle = () => {
    const newValue = !showMessage;
    setShowMessage(newValue);
    localStorage.setItem("pshdsadhgsa", newValue);
  };

  return (
    <div style={{ paddingBlock: "1rem", fontFamily: "sans-serif",fontSize:"13px" }}>
      <label>
        <input
          type="checkbox"
          checked={showMessage}
          onChange={handleToggle}
          style={{ marginRight: "8px" }}
        />
        I agree to receive promotional emails and updates.
      </label>
    </div>
  );
};

export default NotificationToggle;
